import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeMenu } from '../../../store/MenuSlice';
import { Main } from '../../_atoms/Main';
import { Wrap } from '../../_atoms/Wrap';

export const Frame = (props) => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const handleCloseMenu = (e) => {
    ((e.target.elementType !== 'a' && e.target.type !== 'aside' && e.target.type !== 'asideIn' && e.target.type !== 'animation') && ((e.target.type === 'animation' && !state.common.pop_video) || e.target.nodeName === 'CANVAS' || e.target.nodeName === 'H1')) && dispatch(closeMenu(true));
  };

  useEffect(() => {
    window.document.addEventListener('mousedown', handleCloseMenu);
    return () => {
      window.document.addEventListener('mousedown', handleCloseMenu);
    };
  });

  return (
    <Wrap>
      <Main type={props.type}>{props.children}</Main>
    </Wrap>
  );
};

Frame.propTypes = {
  type : PropTypes.string.isRequired
};

Main.defaultProps = {
  type : 'bookMenu'
};